import type { FormStore } from '@atlassian/proforma-common-core/form-system-stores';

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum CloseFormResult {
	Success,
	Cancelled,
	ValidationFailed,
	UnknownError,
}

export type HandleCloseForm = (formId: number, formStore?: FormStore) => Promise<CloseFormResult>;
